import React, { useRef, useEffect, useState } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { pink } from "@mui/material/colors";
import ReCAPTCHA from "react-google-recaptcha";
import { useFormik } from "formik";
import * as Yup from "yup";
import ErrorText from "../common/ErrorText";
import CloseIcon from "@mui/icons-material/Close";
import styles from "../../Styles/modal.module.css";
import apiCall from "../../helpers/apifactory";
import Select from "react-select";

const Corporate = () => {
  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document.getElementById(`${current_page}`);
      // .scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
    },
    false
  );
  // keeping just in case for reporting to google about captcha
  // const YOUR_PRIVATE_KEY = "6Le3utQhAAAAAKR-L_9-laElwYvGEqxDWSBOMRps"
  // const submitHandler = async () => {
  //     if (Captcha == null) {
  //         alert('please verify code');
  //         return;
  //     }
  //     const res = await axios.post(
  //         `https://www.google.com/recaptcha/api/siteverify?secret=${YOUR_PRIVATE_KEY}&response=${Captcha}`
  //     );
  //     // Extract result from the API response
  //     if (res.data.success)
  //         console.log('Human');
  //     else
  //         console.log('BOT!!!');
  // }
  const modalRef = useRef(null);
  const [termCond, setTermCond] = useState(false);
  const [under, setUnder] = useState(false);
  const [show, setShow] = useState(false);
  const [cities, setCities] = useState([]);
  const [originState, setOriginState] = useState("");
  const [newcities, setNewCities] = useState([]);

  const handleChange = (e) => {
    setOriginState(e.value);
  };

  const products = [
    { Description: "Express" },
    { Description: "Overland" },
    { Description: "Warehousing" },
    { Description: "Sentiments" },
    { Description: "MMS" },
  ];

  const formik = useFormik({
    initialValues: {
      compName: "",
      bussName: "",
      city: undefined,
      bussIndustry: "",
      bussType: "",
      compRegNum: "",
      gst_ntn_cnic: "",
      taxFiler: "yes",
      name: "",
      designation: "",
      email: "",
      mobNum: "",
      LandlineNum: "",
      cnic: "",
      product: "",
      averageShipment: "",
      averageWeight: "",
      termCond: false,
      undertak: false,
      capcha: false,
    },
    validationSchema: Yup.object({
      compName: Yup.string().required("This is Required"),
      bussName: Yup.string().required("This is Required"),
      city: Yup.object()?.required("This is Required"),
      bussIndustry: Yup.string().required("This is Required"),
      bussType: Yup.string().required("This is Required"),
      compRegNum: Yup.string().required("This is Required"),
      gst_ntn_cnic: Yup.string()
        .matches(/^[0-9+]{5}-[0-9+]{7}-[0-9]{1}$/, {
          message: "xxxxx-xxxxxxx-x",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      taxFiler: Yup.string().required("This is Required"),
      name: Yup.string().required("This is Required"),
      designation: Yup.string().required("This is Required"),
      email: Yup.string()
        .email("Invalid email address")
        .required("This is Required"),
      mobNum: Yup.string()
        .matches(/^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm, {
          message: "Invalid phone number",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      LandlineNum: Yup.string(),
      cnic: Yup.string()
        .matches(/^[0-9+]{5}-[0-9+]{7}-[0-9]{1}$/, {
          message: "xxxxx-xxxxxxx-x",
          excludeEmptyString: false,
        })
        .required("This is Required"),
      product: Yup.string().required("This is Required"),
      averageShipment: Yup.string().required("This is Required"),
      averageWeight: Yup.string().required("This is Required"),
      termCond: Yup.boolean()
        .required("Terms and conditions must be accepted.")
        .oneOf([true], "Terms and conditions must be accepted."),
      undertak: Yup.boolean()
        .required("Undertakings must be accepted.")
        .oneOf([true], "Undertakings must be accepted."),
      capcha: Yup.string().required(),
    }),
    onSubmit: (values) => {
      const body = {
        toEmailID: "customerservices@tcs.com.pk",
        // toEmailID: "farhan.ahmed@tcs.com.pk",
        emailSubject: "Applicant Information",
        emailText: `
                    name : ${values.name} \n
                    designation : ${values.designation} \n
                    number : ${values.mobNum} \n
                    email : ${values.email} \n
                    TelePhone : ${values.LandlineNum} \n
                    city : ${values.city?.label} \n
                    address : ${values.address} \n
                    `,
        cc: values?.email,
        bcc: values?.email,
        attachments: [],
        replyTo: values?.custEmail,
      };
      // const header = {
      //     Authorization: `Bearer ${'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIk5vdGlmaWNhdGlvbiIsIkludGVybmF0aW9uYWxCb29raW5nIiwiVHJhY2siLCJUVEMiLCJGU1AiLCJDbGFpbVNlcnZpY2UiLCJXTVMiLCJHU00iLCJSTVMiLCJXb3JrZmxvdyIsIkNMUyJdLCJjbGllbnRpZCI6IjIxMTExMTExMSIsImF1ZCI6WyJtaWRkbGV3YXJlLnRyYW56dW1way5jb20iLCJtaWRkbGV3YXJlLnRyYW56dW1way5jb20iXSwiaXNzIjoibWlkZGxld2FyZS50cmFuenVtcGsuY29tIiwianRpIjoiNjFmNzllZTgtMDZjNi00NmY0LWExM2MtNWUwOWZjODU4Mzg1IiwibmJmIjoxNjczMjc4MTU4LCJleHAiOjE3NTk2NzQ1NTgsImlhdCI6MTY3MzI3ODE1OH0.FVA0xgGz6BjVdbXglSR94to8oSTZEaMWxRVWTP8DC38'}`,
      // };
      apiCall
        .sendEmail(body, {})
        .then((res) => {
          setShow(true);
          formik.setValues(formik?.initialValues);
          formik.setTouched({}, false);
        })
        .catch((error) => {
          console.log("===============", error);
        });
    },
  });

  useEffect(() => {
    if (show) {
      modalRef.current.classList.add(styles.visible);
    } else {
      modalRef.current.classList.remove(styles.visible);
    }
  }, [show]);

  useEffect(() => {
    apiCall
      .getCity()
      .then((res) => {
        var cityarr = res?.data?.responseData?.cities.map(
          ({ station_code, station_name }) => ({
            value: station_code,
            label: station_name,
          })
        );
        setCities(res?.data?.responseData?.cities);
        setNewCities(cityarr);
      })
      .catch((error) => {
        console.log("===============", error);
      });
  }, []);

  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">Corporate</h1>
        <div className="flex  justify-center items-center">
          <h2 className="text-[1.1rem]">Account Opening Form</h2>
        </div>
      </div>
      {/* <!-- Heading --> */}
      <form onSubmit={(e) => e?.preventDefault()}>
        <div className="my-[3rem]">
          {/* Company Information */}
          <div className="flex flex-col justify-center mt-[1rem] ">
            <div className="flex flex-col justify-center gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] md:mx-[auto] sm:mx-[auto] mx-[1rem] rounded-md transition-all duration-500 mt-0 pt-0">
              <div className="flex gap-4 mt-4">
                <div className="flex-1 flex flex-col gap-1">
                  <h2 className="font-bold text-[0.9rem] sm:text-[1.2rem] mb-5 mt-0">
                    Company Information
                  </h2>
                  <div className="sm:flex grid gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          name="compName"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.compName}
                          type="text"
                          id="compName"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="compName"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Your Company Name*
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.compName && formik.errors.compName}
                      />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          name="bussName"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.bussName}
                          type="text"
                          id="bussName"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="bussName"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Your Business Name*
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.bussName && formik.errors.bussName}
                      />
                    </div>
                  </div>
                  <div className="sm:flex grid gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        {/* <select
                                                    id="floating_outline"
                                                    className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                                                    placeholder=" "
                                                    name="city"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.city}
                                                >
                                                    <option>Please Select</option>
                                                    {
                                                        cities?.map((data, index) => (
                                                            <option key={index} value={data?.['station code']}>
                                                                {data?.['station name']}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                                <label for="floating_outlined" className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">
                                                    Your City*
                                                </label> */}
                        <Select
                          className="select1"
                          placeholder="Origin (city)"
                          name="city"
                          id="city"
                          value={formik?.values?.city}
                          // value={newcities.find(
                          //   (obj) => obj.value === originState
                          // )}
                          options={newcities}
                          // onChange={handleChange}
                          // onChange={(e) => console.log(e)}
                          // onBlur={(e) => console.log(e?.target?.value)}
                          // onChange={(e) => formik?.handleChange(e)}
                          // onBlur={(e) => formik?.handleBlur(e)}
                          onChange={(e) => {
                            formik?.setFieldValue("city", e);
                          }}
                          onBlur={(e) => {
                            formik?.setFieldTouched("city", true);
                            // formik?.handleBlur(e);
                            // console.log("====", e);
                          }}
                        />
                        {/* <select
                          id="city"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder="Origin (city)"
                          name="city"
                          value={formik?.values?.city}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {newcities?.map((data, index) => {
                            return (
                              <option key={index} value={data?.value}>
                                {data?.label}
                              </option>
                            );
                          })}
                        </select> */}
                      </div>
                      <ErrorText
                        text={formik.touched.city && formik.errors.city}
                      />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          name="bussIndustry"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.bussIndustry}
                          type="text"
                          id="bussIndustry"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />
                        <label
                          for="bussIndustry"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Your Business Industry*
                        </label>
                      </div>
                      <ErrorText
                        text={
                          formik.touched.bussIndustry &&
                          formik.errors.bussIndustry
                        }
                      />
                    </div>
                  </div>
                  <div className="sm:flex grid gap-4">
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <input
                          name="bussType"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.bussType}
                          type="text"
                          id="bussType"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />
                        <label
                          for="bussType"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Your Business Type*
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.bussType && formik.errors.bussType}
                      />
                    </div>
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <input
                          name="compRegNum"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.compRegNum}
                          type="text"
                          id="compRegNum"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />
                        <label
                          for="compRegNum"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Company registration No
                        </label>
                      </div>
                      <ErrorText
                        text={
                          formik.touched.compRegNum && formik.errors.compRegNum
                        }
                      />
                    </div>
                  </div>
                  <div className="sm:flex grid gap-4">
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <input
                          name="gst_ntn_cnic"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.gst_ntn_cnic}
                          type="text"
                          id="gst_ntn_cnic"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />
                        <label
                          for="gst_ntn_cnic"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          GST/NTN/CNIC
                        </label>
                      </div>
                      <ErrorText
                        text={
                          formik.touched.gst_ntn_cnic &&
                          formik.errors.gst_ntn_cnic
                        }
                      />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <select
                          id="taxFiler"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                          name="taxFiler"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.taxFiler}
                        >
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                        <label
                          for="taxFiler"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Tax Filer
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.taxFiler && formik.errors.taxFiler}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="flex-1 flex flex-col"></div>
              </div>
            </div>
          </div>
          {/* Contact Person Details */}
          <div className="flex flex-col justify-center mt-[1rem] ">
            <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] sm:mx-[auto] mx-[1rem] rounded-md transition-all duration-500 mt-0 pt-0">
              <div className="flex gap-4 mt-4">
                <div className="flex-1 flex flex-col gap-1">
                  <h2 className="font-bold text-[0.9rem] sm:text-[1.2rem] mb-5 mt-0">
                    Contact Person Details
                  </h2>
                  <div className="sm:flex grid gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          name="name"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.name}
                          type="text"
                          id="name"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="name"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Name*
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.name && formik.errors.name}
                      />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          name="designation"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.designation}
                          type="text"
                          id="designation"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="designation"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Designation*
                        </label>
                      </div>
                      <ErrorText
                        text={
                          formik.touched.designation &&
                          formik.errors.designation
                        }
                      />
                    </div>
                  </div>

                  <div className="sm:flex grid gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          name="email"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.email}
                          type="email"
                          id="email"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="email"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Email*
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.email && formik.errors.email}
                      />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          name="mobNum"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.mobNum}
                          type="number"
                          id="mobNum"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="mobNum"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Mobile #*
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.mobNum && formik.errors.mobNum}
                      />
                    </div>
                  </div>
                  <div className="sm:flex flex gap-4">
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <input
                          name="LandlineNum"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.LandlineNum}
                          type="number"
                          id="LandlineNum"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="LandlineNum"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Landline #
                        </label>
                      </div>
                      <ErrorText
                        text={
                          formik.touched.LandlineNum &&
                          formik.errors.LandlineNum
                        }
                      />
                    </div>
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <input
                          name="cnic"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.cnic}
                          type="text"
                          id="cnic"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="cnic"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          CNIC*
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.cnic && formik.errors.cnic}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="flex-1 flex flex-col"></div>
              </div>
            </div>
          </div>
          {/* Account Information */}
          <div className="flex flex-col justify-center mt-[1rem] ">
            <div className="flex flex-col gap-3 p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] sm:mx-[auto] mx-[1rem] rounded-md transition-all duration-500 mt-0 pt-0">
              <div className="flex gap-4 mt-4">
                <div className="flex-1 flex flex-col gap-1">
                  <h2 className="font-bold text-[0.9rem] sm:text-[1.2rem] mb-5 mt-0">
                    Account Information
                  </h2>
                  <div className="flex gap-4">
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <select
                          id="product"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                          name="product"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.product}
                        >
                          <option>Please Select</option>
                          {products?.map((each, index) => (
                            <option key={index}>{each?.Description}</option>
                          ))}
                          {/* <option>Express</option>
                          <option>Overland</option>
                          <option>Warehousing</option>
                          <option>Sentiments</option>
                          <option>MMS</option> */}
                        </select>
                        <label
                          for="product"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Product Selection*
                        </label>
                      </div>
                      <ErrorText
                        text={formik.touched.product && formik.errors.product}
                      />
                    </div>
                    <div
                      className="MuiFormControl-root flex-1"
                      inputprops="[object Object]"
                      inputlabelprops="[object Object]"
                    >
                      <div className="relative">
                        <input
                          name="averageShipment"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.averageShipment}
                          type="number"
                          id="averageShipment"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="averageShipment"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Average Monthly Shipments*
                        </label>
                      </div>
                      <ErrorText
                        text={
                          formik.touched.averageShipment &&
                          formik.errors.averageShipment
                        }
                      />
                    </div>
                  </div>

                  <div className="sm:flex grid gap-4">
                    <div className="MuiFormControl-root MuiTextField-root flex-1">
                      <div className="relative">
                        <input
                          name="averageWeight"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.averageWeight}
                          type="text"
                          id="averageWeight"
                          className="block px-2.5 pb-2 pt-2 w-full text-sm text-light bg-transparent rounded border border-gray focus:border-red hover:border-black focus:outline-none focus:ring-0 focus:border-red-600 peer"
                          placeholder=" "
                        />

                        <label
                          for="averageWeight"
                          className="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white bg-gray px-2 pr-0 peer-focus:px-2 peer-focus:text-red-600 peer-focus:dark:text-red-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                        >
                          Average Monthly Weight (kgs)*
                        </label>
                      </div>
                      <ErrorText
                        text={
                          formik.touched.averageWeight &&
                          formik.errors.averageWeight
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-1 flex flex-col"></div>
              </div>
            </div>
          </div>
          {/*  */}
          <div className="flex flex-col justify-center mt-[1rem] ">
            <div className="flex flex-col gap-3 p-8  sm:p-8 shadow-card text-sm md:w-[45rem] sm:w-[40rem] w-[auto] sm:mx-[auto] mx-[1rem] rounded-md transition-all duration-500">
              <h2 className="font-bold text-[0.9rem] sm:text-[1.2rem] text-left">
                Rates &amp; Acceptance
              </h2>
              <div className="flex gap-4">
                <div className="flex-1 flex flex-col">
                  <div className="flex items-center ">
                    <FormGroup>
                      <FormControlLabel
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        checked={formik.values.termCond}
                        name="termCond"
                        control={
                          <Checkbox
                            sx={{ "&.Mui-checked": { color: pink[600] } }}
                          />
                        }
                        label={
                          <p className="text-[0.7rem] sm:text-sm">
                            I have read and hereby accept the{" "}
                            <a
                              rel="noopener noreferrer"
                              target="_blank"
                              href="https://customeraccount.tcscourier.com/accountopening/TermsAndCond.aspx"
                              className="text-[#337ab7]"
                            >
                              Terms and Conditions
                            </a>
                            *
                          </p>
                        }
                      />
                      <ErrorText
                        text={
                          formik?.touched?.termCond && formik?.errors?.termCond
                        }
                      />
                      <FormControlLabel
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        checked={formik.values.undertak}
                        name="undertak"
                        control={
                          <Checkbox
                            sx={{ "&.Mui-checked": { color: pink[600] } }}
                          />
                        }
                        label={
                          <p className="text-[0.7rem] sm:text-sm">
                            I have read and hereby accept the{" "}
                            <a
                              rel="noopener noreferrer"
                              target="_blank"
                              href="https://customeraccount.tcscourier.com/accountopening/RegUndertaking.aspx"
                              className="text-[#337ab7]"
                            >
                              Undertaking
                            </a>
                            *
                          </p>
                        }
                      />
                      <ErrorText
                        text={
                          formik?.touched?.undertak && formik?.errors?.undertak
                        }
                      />
                    </FormGroup>
                  </div>
                  <p className="mt-4 text-xs">
                    A TCS sales representative will contact you within next 24
                    hours (during workdays) for further details and
                    confirmations.
                  </p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="flex-1 flex flex-col"></div>
              </div>
            </div>
            <div className="flex flex-col justify-center mt-[1rem] mb-[0.6rem] sm:mx-[auto]">
              <div className="flex gap-4 md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] sm:mx-[auto]">
                <div className="g-recaptcha">
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_CAPTCH}
                    onChange={(value) => {
                      formik.setFieldValue("capcha", value);
                    }}
                  />
                </div>
              </div>
            </div>
            <button
              type="submit"
              onClick={formik.handleSubmit}
              // onClick={()=>console.log(formik.errors)}
              className="text-white bg-[#D40511] border border-[#F21E26] md:w-[45rem] sm:w-[40rem] w-[auto] mx-[1rem] sm:mx-[auto] rounded-md mt-1 p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
      <div
        ref={modalRef}
        // style={backdropStyle}
        className={`${styles.modal__wrap}`}
        onClick={() => setShow(false)}
      >
        <div
          className={`flex flex-col justify-center items-center ${styles.modal}`}
        >
          <div className="bg-white w-full h-[106%] relative z-[1000] rounded-3xl">
            <div className="flex justify-center items-center">
              <img
                src="/popup-circle.png"
                alt=""
                className="mx-auto w-[12.5rem]"
              />
              <img
                src="/popup-icon.png"
                alt=""
                className="absolute top-[-3.5rem] mx-auto w-[7rem]"
              />
            </div>
            <div className="absolute right-[1rem] top-[1rem] ">
              <CloseIcon fontSize="large" style={{ color: "#f21e26" }} />
            </div>
            <div className="flex flex-col text-center justify-center item-center mt-[6rem]">
              <h2 className="font-bold text-xl">Thank you for submitting.</h2>
              <p>We’ll contact you soon.</p>
            </div>
          </div>
          <div className="mx-auto bg-[#ed1d25] w-[80%] h-[2rem] rounded-full mt-[-1.2rem]"></div>
        </div>
      </div>
    </div>
  );
};

export default Corporate;
